export default function sanitizeFileName(filename) {
  return filename.replace(/\?.*/, '') // Rip any params in URL/filename
  .replace(/([^0-9A-Za-z.-]|_)+/g, '_');
}